var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18965(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.501,
    height: 46.501,
    viewBox: "0 0 46.501 46.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18965",
    "data-name": "Group 18965",
    transform: "translate(-574.154 -7031.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M23.251,0A23.251,23.251,0,1,1,0,23.251,23.251,23.251,0,0,1,23.251,0Z",
    transform: "translate(574.154 7031.622)",
    fill: "#b5153a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M53.94,36.8a11.8,11.8,0,0,1-3.4.931,5.932,5.932,0,0,0,2.6-3.273A11.844,11.844,0,0,1,49.387,35.9a5.921,5.921,0,0,0-10.082,5.4A16.8,16.8,0,0,1,27.11,35.11a5.923,5.923,0,0,0,1.831,7.9,5.875,5.875,0,0,1-2.68-.741c0,.025,0,.05,0,.075a5.92,5.92,0,0,0,4.746,5.8,5.939,5.939,0,0,1-2.672.1,5.923,5.923,0,0,0,5.527,4.109,11.943,11.943,0,0,1-8.759,2.45,16.735,16.735,0,0,0,9.068,2.658C45.054,57.464,51,48.448,51,40.63c0-.256-.006-.512-.017-.765A12,12,0,0,0,53.94,36.8Z",
    transform: "translate(558.043 7009.353)",
    fill: "#f5fcff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18965);
export default __webpack_public_path__ + "static/media/Group 18965.9c12db52d0f8c4a5aba53ddc1d5edfd9.svg";
export { ForwardRef as ReactComponent };